import { useEffect, useState } from 'react';
import './styles/admin.scss';
import { ApiHelper } from '../../apiHelper/ApiHelper';
import AdminQuestionModal from '../../components/admin/AdminQuestionModal';
import VyukaTabs from '../../components/admin/VyukaTabs';
import { useConfirm } from '../../components/admin/useConfirm';
import { SUBJECTS, QTYPE_LABEL, QSTATUS_LABEL, QSTATUS_CLASS } from './adminConstants';

type QRef = { id: string; text: string; type: number; subject: number; status: number; topic: string; difficulty: number; options: number };

export default function AdminQuestions() {
    const [subject, setSubject] = useState(0);
    const [questions, setQuestions] = useState<QRef[]>([]);
    const [loaded, setLoaded] = useState(false);
    const [modal, setModal] = useState<{ open: boolean; id: string | null }>({ open: false, id: null });
    const api = new ApiHelper();
    const { ask, confirmModal } = useConfirm();

    useEffect(() => { setLoaded(false); load(); }, [subject]);

    async function load() {
        try { setQuestions(await (await api.adminContentApi.questions({ subject })).json()); } catch (x: any) { api.adminError(x); } finally { setLoaded(true); }
    }
    function del(q: QRef) {
        ask(<>Smazat otázku „{q.text || "(bez znění)"}“?</>, async () => {
            try { await api.adminContentApi.deleteQuestion(q.id); await load(); } catch (x: any) { api.adminError(x); }
        });
    }

    return (
        <div>
            <div className="adminHead">
                <div><h1>Výuka</h1><p>Banka otázek pro volné testy a modelové testy</p></div>
                <button className="aBtn" onClick={() => setModal({ open: true, id: null })}>+ Nová otázka</button>
            </div>

            <VyukaTabs />

            <div className="pills">
                {SUBJECTS.map(s => <span key={s.v} className={"pill" + (subject === s.v ? " on" : "")} onClick={() => setSubject(s.v)}>{s.l}</span>)}
            </div>

            <table className="aTable">
                <thead><tr><th>Znění</th><th>Téma</th><th>Typ</th><th>Stav</th><th>Obtížnost</th><th>Možnosti</th><th></th></tr></thead>
                <tbody>
                    {questions.map(q => (
                        <tr key={q.id} onClick={() => setModal({ open: true, id: q.id })}>
                            <td>{q.text || <span className="muted">(bez znění)</span>}</td>
                            <td>{q.topic}</td>
                            <td>{QTYPE_LABEL[q.type]}</td>
                            <td><span className={QSTATUS_CLASS[q.status]}>{QSTATUS_LABEL[q.status]}</span></td>
                            <td>{q.difficulty}</td>
                            <td>{q.options}</td>
                            <td onClick={e => e.stopPropagation()}><span className="x" onClick={() => del(q)}>×</span></td>
                        </tr>
                    ))}
                    {loaded && questions.length === 0 && <tr><td colSpan={7} className="muted">Žádné otázky.</td></tr>}
                </tbody>
            </table>

            {modal.open && <AdminQuestionModal questionId={modal.id} subject={subject} onClose={() => setModal({ open: false, id: null })} onSaved={() => { setModal({ open: false, id: null }); load(); }} />}
            {confirmModal}
        </div>
    );
}
